module.exports = __webpack_public_path__ + "1c12d4b60580275c7812fa3c50c253b3.svg";